import React from 'react';

interface LgcyTypeSelectProps {
  selectedType: string;
  errors?: any;
  register: Function;
};

const LgcyTypeSelect: React.FC<LgcyTypeSelectProps> = ({ selectedType, errors, register }) => {
  return (
    <div className="memory-lgcy-type-select-container inner">
      <hr />
      <div className="memory-lgcy-type-select-header">
          Is this a living LGCY or a memorial LGCY?
      </div>
      {errors.lgcy_type && (
        <div className="error-message">
          {errors.lgcy_type.message}
        </div>
      )}
      <div className="memory-lgcy-type-select">
        <label>
          <input
            type="radio"
            value="living"
            defaultChecked={selectedType === 'living'}
            {...register('lgcy_type')}
          />
          <div className="memory-lgcy-type-option">
            <div className="memory-lgcy-type-label">
              <h5>Living LGCY</h5>
              <span>This person or story is still being written</span>
            </div>
          </div>
        </label>
        <label>
          <input
            type="radio"
            value="memorial"
            defaultChecked={selectedType === 'memorial'}
            {...register('lgcy_type')}
          />
          <div className="memory-lgcy-type-option">
            <div className="memory-lgcy-type-label">
              <h5>Memorial LGCY</h5>
              <span>Honoring someone who has passed</span>
            </div>
          </div>
        </label>
      </div>
    </div>
  );
}

export default LgcyTypeSelect;
